module.exports = __webpack_public_path__ + "static/media/enzo_fernandez.23451fd5.jpg";